<section id="header" [class.loading]="this.isLoading">
    <div id="title">
        <mat-icon class="mr-2">face_retouching_natural</mat-icon>
        Sofía 
    </div>
    <mat-icon [svgIcon]="'close'" (click)="close()"> </mat-icon>
</section>
<mat-progress-bar *ngIf="this.isLoading" mode="indeterminate"></mat-progress-bar>
<section id="main-section" [class.loading]="this.isLoading">
    <div class="destination-wrapper" *ngIf="this.activeComponent == 'DESTINATION'">
        <form [formGroup]="this.form">
            <mat-form-field>
                <mat-label>¿Para tu viaje a qué destino necesitas ayuda?</mat-label>
                <input formControlName="destination" matInput autocomplete="off">
            </mat-form-field>
            <button mat-flat-button color="primary" [disabled]="!this.form.valid"
                (click)="this.saveDestination()">Iniciar conversación</button>
        </form>
    </div>
    <div class="chat-wrapper" *ngIf="this.activeComponent == 'CHAT'">
        <div class="chat" #chat></div>
    </div>
</section>